<template>
  <ContainerBox title="好感度对话">
    <div class="conversation-info">
      <ElScrollbar wrapStyle="height: 450px; overflow-x: hidden;">
        <template v-for="key in Object.keys(dataSource)">
          <div class="item" :key="key" v-if="dataSource[key].question.hasValue && dataSource[key].question.value">
            <div class="title">
              {{ dataSource[key].question.value }}
            </div>
            <div class="answer">
              <BorderBg />
              <img class="icon" src="@/assets/nikke_imgs/answer100-icon.png" alt="" />
              <span>{{ dataSource[key].answer100.value }}</span>
            </div>
            <div class="answer">
              <BorderBg />
              <img class="icon" src="@/assets/nikke_imgs/answer120-icon.png" alt="" />
              <span>{{ dataSource[key].answer120.value }}</span>
            </div>
          </div>
        </template>
      </ElScrollbar>
    </div>
  </ContainerBox>
</template>

<script>
import ContainerBox from "./containerBox.vue";
import BorderBg from "./borderBg.vue";
export default {
  name: "ConversationInfo",
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: { ContainerBox, BorderBg },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.conversation-info {
  .item {
    margin-top: 10px;
    .title {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 37px;
      background: #45474a;
      border-radius: 4px 4px 4px 4px;
      margin-bottom: 6px;
      font-weight: 500;
      font-size: 14px;
      color: #f2f4f1;
      line-height: 16px;
    }
    .answer {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      width: 100%;
      height: 38px;
      margin-bottom: 6px;
      .icon {
        min-width: 22px;
        height: 22px;
      }
    }
  }
}
</style>
